var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 197,
    rx: 20,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.44 37.6844C95.5115 37.6678 97.5954 37.6844 99.6669 37.6844C100.871 51.4418 100.97 65.4483 99.6669 79.1974L98.3177 80.0193C91.6009 79.7204 84.8924 79.6831 78.1881 79.9114L76.8348 79.1974C60.6489 77.3459 52.2799 58.2915 62.7328 45.3726C70.6992 35.5216 82.1194 37.7758 93.44 37.6844Z",
    fill: "#F05023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6676 79.1969C99.9873 79.1969 100.481 79.2716 100.498 79.475C100.905 85.1499 100.456 91.0239 99.6676 96.6323C100.78 97.8445 100.78 102.062 99.6676 103.274V120.71L98.9661 121.312C92.1496 121.557 85.271 121.59 78.3383 121.411L76.8355 120.71C71.5883 119.697 66.9056 117.729 63.3397 113.657C52.3014 101.058 60.2096 80.8989 76.8355 79.1969C83.5772 78.5078 92.6437 79.1969 99.6676 79.1969Z",
    fill: "#8162AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.915 79.1985C122.026 80.3484 118.008 80.3235 117.103 79.1985C111.507 80.0163 105.857 80.2944 100.157 80.0287L99.6673 79.1985C99.6673 65.3705 99.5469 51.5135 99.6673 37.6855C115.6 37.7063 140.043 34.5804 141.172 57.4125C141.716 68.4217 133.48 77.4093 122.915 79.1985Z",
    fill: "#F37264"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6669 120.71C99.6669 135.588 103.112 157.237 83.9044 161.612C54.9201 168.217 48.2822 123.736 76.8348 120.71C83.9791 119.95 92.3814 121.274 99.6669 120.71Z",
    fill: "#48BA7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.914 79.1991C142.052 81.009 148.129 107.403 131.341 117.723C119.045 125.283 101.481 117.611 99.667 103.277C99.4802 101.786 99.4802 98.1248 99.667 96.6345C99.6587 87.8213 108.293 79.1991 117.102 79.1991C118.53 79.0164 121.44 79.0579 122.914 79.1991Z",
    fill: "#48B8E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.45ee6be496ec1519cfe3970c5477e113.svg";
export { ForwardRef as ReactComponent };